export const FEEDBACK_TITLE = 'room.favorites.toast.title';
export const FEEDBACK_DESCRIPTION = 'room.favorites.toast.text';
